<template>
  <div>
    <div class="doctorPage doctorSeach managerPlan">
      <div class="selectSearch">
        <el-form
          ref="preservationform"
          :model="userListParameter"
          class="qcFrom"
          :inline="true"
        >
          <!--<el-form-item label="状态">
						    <el-select v-model="userListParameter.enable" placeholder="请选择" size="mini" class="name" >
								<el-option label="全部" value="-1"></el-option>
								<el-option label="启用" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
						    </el-select>
						  </el-form-item> -->
          <el-form-item label="关键词">
            <el-input
              v-model="userListParameter.keyword"
              class="name"
              placeholder="用户名/手机号"
              size="mini"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="角色名称" v-if="!staffFlag">
            <el-select
              v-model="userListParameter.roleGuids"
              placeholder="请选择角色名称"
              size="mini"
              class="name"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in rolesList"
                :key="item.RoleGuid"
                :label="item.RoleName"
                :value="item.RoleGuid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" round>查询</el-button>
          </el-form-item>
          <a
            href="javascript:;"
            v-if="staffFlag"
            class="addbtn"
            @click="addUser"
            >添加用户</a
          >
          <!-- <a href="javascript:;" v-if="!staffFlag" class="addbtn" @click="newlyBuild">新建用户</a> -->
        </el-form>
      </div>
      <!-- 中间内容 -->
      <div class="centerHome">
        <div class="ccHomel">
          <div class="compentTable">
            <el-table
              class="qcTable"
              :data="userlist.Users"
              v-loading="loading"
            >
              <el-table-column
                prop="Name"
                label="用户名称"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="LoginId"
                label="手机号"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="RoleNames"
                label="用户角色"
                min-width="100"
                v-if="!staffFlag"
              >
              </el-table-column>
              <el-table-column
                prop="CreateDt"
                label="创建时间"
              ></el-table-column>
              <el-table-column prop="Enable" label="状态">
                <template slot-scope="scope">
                  <span v-show="scope.row.Enable == 0">
                    禁用
                  </span>
                  <span v-show="scope.row.Enable == 1">
                    启用
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="操作" width="180">
                <template slot-scope="scope">
                  <span
                    class="table-task-btn detail"
                    @click="showClick(scope.row)"
                    >编辑</span
                  >
                  <span
                    class="table-task-btn delete"
                    v-if="!staffFlag"
                    @click="delterClick(scope.row)"
                    >删除</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pages">
              <el-pagination
                class="pageAll"
                layout="prev, pager, next"
                :total="userlist.TotalCount"
                :page-size="userListParameter.PageCount"
                :current-page="userListParameter.PageIndex"
                @current-change="currentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="70%"
        class="scrollbar userListParameter dialogFrom"
      >
        <el-form
          label-width="100px"
          class="qcFrom dialogScoped"
          ref="setuserListParameter"
          :rules="rules"
          distinguishCancelAndClose
          :model="submitParameter"
        >
          <el-row>
            <el-col :span="16">
              <el-form-item label="状态">
                <div class="exportTab marr20">
                  <div class="sliderScreeningR">
                    <a
                      href="javascript:;"
                      @click="seachTab(1)"
                      :class="submitParameter.Enable ? 'active' : ''"
                      >启用</a
                    >
                    <a
                      href="javascript:;"
                      @click="seachTab(0)"
                      :class="!submitParameter.Enable ? 'active' : ''"
                      >禁用</a
                    >
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="姓名" prop="Name">
                <el-input
                  size="small"
                  v-model="submitParameter.Name"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="手机号" prop="LoginId">
                <el-input
                  size="small"
                  v-model="submitParameter.LoginId"
                  maxlength="11"
                  placeholder="请输入手机号"
                  v-if="newlyBuildFlag"
                ></el-input>
                <span class="colwhite" v-else>{{
                  submitParameter.LoginId
                }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="用户角色" prop="RoleGuidList">
                <el-select
                  size="small"
                  v-model="submitParameter.RoleGuidList"
                  class="roleRadius"
                  style="width: 100%;"
                  @change="$forceUpdate()"
                  multiple
                  placeholder="请选择用户角色"
                >
                  <el-option
                    v-for="item in rolesList"
                    :key="item.RoleGuid"
                    :label="item.RoleName"
                    :value="item.RoleGuid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="服务开通期限" prop="ExpiresTime">
                <el-radio-group v-model="submitParameter.ExpiresTime">
                  <el-radio :label="0">长期</el-radio>
                  <el-radio :label="1">
                    <span style="margin-right: 10px;">限期</span>
                    <el-date-picker
                      class="time-picker-expires-time"
                      v-model="LastLoginTime"
                      style="width: 313px;"
                      v-show="submitParameter.ExpiresTime === 1"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-radio>
                  <div
                    style="font-size: 12px; color: #999; margin-top: 10px; height: 40px;line-height: 16px;"
                  >
                    温馨提示：医院/租户账号可使用期限，可选择月/年/长期，可进行修改，到期后当前医院/租户医生将不能继续登录使用平台。
                    <br />
                    规则：到期时间为截止日期23:59:59.选择长期时，无截止日期。
                  </div>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
						<el-col :span="16">
							<el-form-item label="选择中心" prop="HospitalGuid">
								<el-select size="small" v-model="submitParameter.HospitalGuid" @change="hospitalsChange" style="width: 100%;"
								 filterable placeholder="请选择中心">
									<el-option v-for="item in allHospitalsData.Hospitals" :key="item.HospitalGuid" :label="item.ShortName" :value="item.HospitalGuid">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row> -->
          <!-- 	<el-row>
						<el-col :span="16">
							<el-form-item label="所属区域" prop="RegionGuidList">
								<el-select size="small" v-model="submitParameter.RegionGuidList" class="roleRadius" style="width: 100%;" @change="$forceUpdate()" multiple placeholder="请选择中心所属区域">
									<el-option v-for="item in regionList" :key="item.RegionGuid" :label="item.Name" :value="item.RegionGuid">{{item.Name}}
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row> -->
        </el-form>
        <div class="dialog-footer mart25" align="center">
          <el-button type="primary" @click="preservation()">保 存</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="添加人员管理"
        :visible.sync="addUserflag"
        :close-on-click-modal="false"
        width="50%"
        class="scrollbar userListParameter dialogFrom"
      >
        <span class="white">人员管理：</span>
        <el-select
          size="small"
          class="roleRadius"
          @change="$forceUpdate()"
          v-model="UserName"
          value-key="UserGuid"
          multiple
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          style="width:240px"
          placeholder="请选择人员"
        >
          <el-option
            v-for="item in userList"
            :key="item.UserGuid"
            :label="item.Name"
            :value="item"
          >
            <span>{{ item.Name }}</span>
            <span class="rt">{{ item.LoginId }}</span>
          </el-option>
        </el-select>
        <el-button
          type="primary"
          class="marl10"
          size="mini"
          @click="addRegion()"
          >添加</el-button
        >
        <el-table
          class="qcTable mart10"
          :data="hospitalUsersList"
          max-height="230"
        >
          <el-table-column
            prop="Name"
            label="姓名"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="LoginId"
            label="手机号"
            min-width="100"
          ></el-table-column>
          <el-table-column prop="" label="操作" width="180">
            <template slot-scope="scope">
              <span
                class="table-task-btn delete"
                @click="deldialogClick(scope.row)"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="center">
          <el-button type="primary" class="mart40" @click="dialogSubmit"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import { mapState, mapActions, mapMutations} from 'vuex'
import axios from "@/js/api";
export default {
  data() {
    var validateRoleGuidList = (rule, value, callback) => {
      if (this.submitParameter.RoleGuidList.length <= 0) {
        callback(new Error("请至少选择一个用户角色"));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          // 不能选过去的日期,今天的可以选
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      LastLoginTime: "",
      submitParameter: {
        UserGuid: "",
        Name: "",
        LoginId: "",
        Password: "",
        HospitalGuid: "",
        HospitalName: "",
        LoginGuid: "",
        Enable: "1",
        IsDeleted: true,
        RoleGuidList: [],
        RegionGuidList: [],
        ExpiresTime: 0,
      },
      newlyBuildFlag: false,
      total: 0,
      title: "新建用户",
      dialogVisible: false,
      rules: {
        Name: [
          {
            required: true,
            message: "请输入用户名称",
            trigger: "blur",
          },
        ],
        ExpiresTime: [
          {
            required: true,
            message: "请选择服务开通期限",
            trigger: "blur",
          },
        ],
        // LoginId: [{
        // 	required: true,
        // 	message: '请输入手机号',
        // 	trigger: 'blur'
        // }, {
        // 	pattern: /^1[3-9]\d{9}$/,
        // 	message: '手机号格式错误'
        // }],
        RoleGuidList: [
          {
            required: true,
            validator: validateRoleGuidList,
            message: "请选择用户角色",
            trigger: "change",
          },
        ],
      },
      message: "保存",
      regionList: [],
      staffFlag: false,
      userList: [],
      addUserflag: false,
      hospitalUsersList: [],
      UserName: [],
      UserGuids: [],
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        this.initHtml();
      },
      deep: true,
    },
  },
  computed: {
    ...Vuex.mapState("breadcrumb", ["loading", "allHospitalsData"]),
    ...Vuex.mapState("admin", ["userlist", "userListParameter", "rolesList"]),
  },
  activated() {
    this.initHtml();
    axios.ajaxGet("get", axios.Api.api.manager.GetAllRegions).then((res) => {
      this.regionList = res.data.Regions;
    });
    this.GetRoles({
      enable: "1",
    });
    this.getAllHospitals({
      enable: -1,
      name: "",
      pageIndex: 1,
      pageCount: 999999,
    });
  },
  methods: {
    ...Vuex.mapMutations("breadcrumb", ["setLoading"]),
    ...Vuex.mapActions("breadcrumb", ["getAllHospitals"]),
    ...Vuex.mapActions("admin", ["GetList", "GetRoles", "AddUser2Hospital"]),
    dialogSubmit() {
      this.hospitalUsersList.forEach((item) => {
        this.UserGuids.push(item.UserGuid);
      });
      this.AddUser2Hospital({
        HospitalGuid: this.$route.query.HospitalGuid,
        UserGuids: this.UserGuids,
      }).then(() => {
        this.addUserflag = false;
        this.GetList();
      });
    },
    deldialogClick(row) {
      let _this = this;
      this.$confirm("确定删除该人员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let list = _this.hospitalUsersList;
          for (let i = 0; i < list.length; i++) {
            if (list[i].UserGuid == row.UserGuid) {
              list.splice(i, 1); //删除下标为i的元素
            }
          }
          _this.hospitalUsersList = list;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    remoteMethod(query) {
      if (query !== "") {
        // 获取医生列表
        axios
          .ajaxGet("get", axios.Api.api.admin.GetList, {
            keyword: query,
            pageIndex: 1,
            pageCount: 999999,
          })
          .then((res) => {
            this.userList = res.data.Users;
          });
      } else {
        this.userList = [];
      }
    },
    initHtml() {
      let HospitalGuid = this.$route.query.HospitalGuid;
      this.staffFlag = HospitalGuid ? true : false;
      this.userListParameter.pageIndex = 1;
      this.userListParameter.HospitalGuid = HospitalGuid ? HospitalGuid : "";
      this.GetList();
    },
    addRegion() {
      this.hospitalUsersList = this.UserName;
    },
    addUser() {
      this.addUserflag = true;
      this.UserGuids = [];
      this.UserName = [];
      this.hospitalUsersList = [];
    },
    hospitalsChange(value) {
      this.allHospitalsData.Hospitals.forEach((item) => {
        if (item.HospitalGuid == value) {
          this.submitParameter.HospitalName = item.HospitalName;
        }
      });
    },
    newlyBuild() {
      this.dialogVisible = true;
      this.newlyBuildFlag = true;
      this.submitParameter = {
        UserGuid: "",
        Name: "",
        LoginId: "",
        Password: "",
        HospitalGuid: "",
        HospitalName: "",
        LoginGuid: "",
        Enable: "1",
        IsDeleted: true,
        RoleGuidList: [],
        RegionGuidList: [],
        ExpiresTime: 0,
        LastLoginTime: "",
      };
    },
    delterClick(row) {
      let _this = this;
      _this.submitParameter = row;
      this.$confirm("确定删除此用户？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          _this.message = "删除";
          _this.submitParameter.IsDeleted = true;
          _this.updateRole();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    showClick(row) {
      this.title = "编辑用户";
      this.message = "修改";
      this.dialogVisible = true;
      this.newlyBuildFlag = false;
      this.submitParameter = JSON.parse(JSON.stringify(row));
      this.LastLoginTime = row.ExpiresTime ? row.ExpiresTime : "";
      this.submitParameter.ExpiresTime = row.ExpiresTime ? 1 : 0;
      this.submitParameter.RoleGuidList = row.RoleGuids.split(",");
    },
    // 增删改请求
    updateRole() {
      let _this = this;
      _this.setLoading(true);
      let params = {
        ..._this.submitParameter,
        ExpiresTime:
          _this.submitParameter.ExpiresTime === 0 ? null : _this.LastLoginTime,
      };
      axios
        .ajaxPost("post", axios.Api.api.admin.CreateOrUpdateUser, params)
        .then((res) => {
          if (res.data.StatusCode == 200) {
            _this.$message.success(_this.message + "成功");
            _this.setLoading(false);
            _this.GetList();
            this.dialogVisible = false;
          }
        });
    },
    search() {
      this.userListParameter.pageIndex = 1;
      this.GetList();
    },
    //分页
    currentChange(val) {
      this.userListParameter.pageIndex = val;
      this.GetList();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    // 启用禁用
    seachTab(type) {
      this.submitParameter.Enable = type;
    },
    preservation() {
      this.$refs.setuserListParameter.validate((valid) => {
        if (valid) {
          if (this.submitParameter.ExpiresTime === 1 && !this.LastLoginTime) {
            this.$message.error("请选择服务开通期限");
            return false;
          }
          this.updateRole();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";
@import "@/assets/style/mixin.scss";

.dialogScoped .exportTab .sliderScreeningR a {
  @include bg-color(dialogTabsColor);
}

.dialogScoped >>> .el-select__tags {
  left: 20px;
}

.dialogFrom .roleRadius >>> .el-input__inner {
  border-radius: 6px;
}

.dialogFrom .el-radio-group {
  // height: 40px;
  // padding-top: 12px;
}

.dialogFrom .el-radio {
  height: 40px;
  line-height: 40px;
}

::v-deep
  .dialogFrom
  .el-radio-group
  .el-radio
  .el-radio__label
  .time-picker-expires-time
  .el-input__prefix {
  position: relative !important;
}
</style>
